import React, {useState} from 'react';
import {SearchInput} from '../../general/SearchInput';

export const DebugHeader = ({search, searchByEmail}) => {
  const [deviceId, setDeviceId] = useState('');
  const [email, setEmail] = useState('');

  return <div className={'debug-header'} style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
    <div style={{display: 'flex', alignItems: 'center'}}>
      <SearchInput
        value={deviceId}
        placeholder={'device id'}
        style={{width: '400px'}}
        handleChange={(value) => {setDeviceId(value)}}
        handleKeyPress={(e) => {
          if (e.key === 'Enter' && deviceId.length !== 0) {
            search(deviceId);
          }
        }}
      />
      <button
        className={'onelight-btn-apply'}
        onClick={() => {search(deviceId)}}
        style={{marginLeft: '20px', minWidth: '70px'}}
      >
        Search
      </button>
    </div>
    <div style={{display: 'flex', alignItems: 'center'}}>
      <SearchInput
        value={email}
        placeholder={'email (web user)'}
        style={{width: '400px'}}
        handleChange={(value) => {setEmail(value)}}
        handleKeyPress={(e) => {
          if (e.key === 'Enter' && email.length !== 0) {
            searchByEmail(email);
          }
        }}
      />
      <button
        className={'onelight-btn-apply'}
        onClick={() => {searchByEmail(email)}}
        style={{marginLeft: '20px', minWidth: '70px'}}
      >
        Search
      </button>
    </div>
  </div>;
};
